import { render } from "./loves.vue?vue&type=template&id=4217286d&scoped=true"
import script from "./loves.vue?vue&type=script&lang=js"
export * from "./loves.vue?vue&type=script&lang=js"

import "./loves.vue?vue&type=style&index=0&id=4217286d&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4217286d"]])

export default __exports__